import { Environment } from '../app/core/models/Environment';
import packageInfo from '../../package.json';

export const environment: Environment = {
  production: true,
  enableSentry: true,
  name: 'production',
  appName: 'Sunny Street',
  appVersion: `v ${packageInfo.version}`,
  beApiUrl: 'https://api.sunnystreet.com',
  wsApiUrl: 'https://api.sunnystreet.com/ws',
  baseUrl: 'https://sunnystreet.app',
  stripePublishableKey:
    'pk_live_51OjOE7DGEe6UUXl1QwAxU7Wbe25SOaHiCdkJ1ry73QPQ6yCCrboXASfalu1g3NjtyvmU1HvD0OtIeo7JmM45QsSm00w4XyVmwF',
  googleClientId:
    '753537782097-mccpr0prippjg15gk4psp1khfno07k2u.apps.googleusercontent.com',
  pushNotificationVapidPublicKey:
    'BPcbX-1YGqYQrkkOtY0q6lYoTUP9EP-QxSyJvaQv3cIzF5TFFTWSrTGUB9UUUBlCY1WXexhH1k1Ze3AOkpATdaY',
};
